var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 952,
    height: 396,
    viewBox: "0 0 952 396",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 417,
    cy: 161,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 515,
    cy: 116,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 423,
    cy: 279,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 366,
    cy: 394,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 327,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 362,
    cy: 209,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 548,
    cy: 211,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 607,
    cy: 281,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.21,
    cx: 789,
    cy: 281,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 65,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 192,
    cy: 132,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743,
    cy: 2,
    r: 2,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M834 150C827.373 150 822 144.627 822 138C822 131.373 827.373 126 834 126C840.627 126 846 131.373 846 138C846 144.627 840.627 150 834 150Z",
    fill: "url(#paint0_linear_701_17365)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 206C1.79086 206 4.76837e-07 204.209 4.76837e-07 202C4.76837e-07 199.791 1.79086 198 4 198C6.20914 198 8 199.791 8 202C8 204.209 6.20914 206 4 206Z",
    fill: "url(#paint1_linear_701_17365)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M948 206C945.791 206 944 204.209 944 202C944 199.791 945.791 198 948 198C950.209 198 952 199.791 952 202C952 204.209 950.209 206 948 206Z",
    fill: "url(#paint2_linear_701_17365)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154 326C149.582 326 146 322.418 146 318C146 313.582 149.582 310 154 310C158.418 310 162 313.582 162 318C162 322.418 158.418 326 154 326Z",
    fill: "url(#paint3_linear_701_17365)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_701_17365",
    x1: 834,
    y1: 126,
    x2: 834,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_701_17365",
    x1: 4,
    y1: 198,
    x2: 4,
    y2: 206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD734F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_701_17365",
    x1: 948,
    y1: 198,
    x2: 948,
    y2: 206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD734F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_701_17365",
    x1: 154,
    y1: 310,
    x2: 154,
    y2: 326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9AEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A32"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.16862618d871f4871a012e1655dc16dc.svg";
export { ForwardRef as ReactComponent };